define(["require", "exports", "jquery", "knockout", "../../utils/kendoUtils", "../../utils/tools", "../../models/UserContext", "../../models/CustomerBankingInfoModel"], function (require, exports, $, ko, KendoUtils, tools, UserContext, CustomerBankingInfoModel) {
    "use strict";
    var CustomerBankingInfo = /** @class */ (function () {
        function CustomerBankingInfo(customerId, initCallback) {
            this.userCanViewCustomerBankingInfo = ko.observable(UserContext.hasAccess("Admin,CustomerBankingInfo.View,CustomerBankingInfo.Edit,CustomerBankingInfo.Delete"));
            this.userCanEditCustomerBankingInfo = ko.observable(UserContext.hasAccess("Admin,CustomerBankingInfo.Edit,CustomerBankingInfo.Delete"));
            this.userCanDeleteCustomerBankingInfo = ko.observable(UserContext.hasAccess("Admin,CustomerBankingInfo.Delete"));
            this.customerId = ko.observable(0);
            this.editModel = ko.observable(new CustomerBankingInfoModel());
            this.isLookupDataLoaded = false;
            this.isInitGridRequested = false;
            var self = this;
            self.customerId(customerId);
            self.isLookupDataLoaded = false;
            if (self.userCanViewCustomerBankingInfo()) {
                // Get lookup data:
                var getLookupData = tools.ajaxGet({
                    url: "/CustomerBankingInfo/GetBankingInfoLookupData",
                    success: function (data) {
                        if (data.Success) {
                            self.lookupLists = data.Data.lookupLists;
                            self.customerBankingInfoGridStructure = self.lookupLists.GridStructures.CustomerBankingInfoStructure;
                        }
                    }
                });
                $.when(getLookupData).done(function () {
                    self.isLookupDataLoaded = true;
                    if (self.isInitGridRequested) {
                        self.initGrid();
                    }
                    if (initCallback) {
                        initCallback(self);
                    }
                });
            }
        }
        CustomerBankingInfo.prototype.initGrid = function () {
            if (this.userCanViewCustomerBankingInfo()) {
                if (!this.isLookupDataLoaded) {
                    this.isInitGridRequested = true;
                }
                else {
                    this.initCustomerBankingInfo();
                }
            }
        };
        CustomerBankingInfo.prototype.initCustomerBankingInfo = function () {
            var self = this;
            var gridId = "divCustomerBankingInfoTable";
            var columns = self.customerBankingInfoGridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function () {
                    var html = "";
                    if (self.userCanEditCustomerBankingInfo()) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    if (self.userCanDeleteCustomerBankingInfo()) {
                        html += '&nbsp;<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            });
            self.customerBankingInfoTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/CustomerBankingInfo/GetCustomerBankingInfo?id=" + self.customerId(),
                            type: "POST",
                            data: function () {
                                var data = {};
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.customerBankingInfoGridStructure.model
                    },
                    serverSorting: false,
                    serverFiltering: false
                },
                gridOptions: {
                    pageable: true,
                    columns: columns,
                    resizable: true
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerBankingInfoTable.initGrid(gridOptions);
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.editCustomerBankingInfo(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                self.deleteCustomerBankingInfoConfirm(data);
                event.preventDefault();
            });
        };
        CustomerBankingInfo.prototype.editCustomerBankingInfo = function (id) {
            var self = this;
            var title = $.isNumeric(id) ? "Edit Banking Info" : "Add Banking Info";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().CustomerId()) {
                        tools.error("Customer is a required field");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveCustomerBankingInfo(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/CustomerBankingInfo/GetCustomerBankingInfoById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new CustomerBankingInfoModel(result.Data));
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new CustomerBankingInfoModel());
                        self.editModel().CustomerId(self.customerId());
                        self.editModel().ShowAllData(true);
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'customer-banking-info-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                        self.editModel().ShowAllData.subscribe(function () {
                            $(window).trigger("resize");
                        });
                    });
                }
            });
        };
        CustomerBankingInfo.prototype.saveCustomerBankingInfo = function (btn, modal) {
            var self = this;
            var obj = tools.modelToFormData(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerBankingInfo/SaveCustomerBankingInfo",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    self.customerBankingInfoTable.refresh();
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        CustomerBankingInfo.prototype.deleteCustomerBankingInfoConfirm = function (item) {
            var self = this;
            tools.confirmModal({
                title: "Delete Customer Banking Info",
                text: "Are you sure you want to delete Customer Banking Info?",
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {}
            }, function (modal) {
                $(modal).modal("hide");
                self.deleteCustomerBankingInfo(item.Id);
            });
        };
        CustomerBankingInfo.prototype.deleteCustomerBankingInfo = function (id) {
            var self = this;
            var data = {
                id: id
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/CustomerBankingInfo/DeleteCustomerBankingInfoConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Customer banking info deleted successfully");
                    self.customerBankingInfoTable.refresh();
                }
            }).always(function () {
                //btn.button("reset");
            });
        };
        return CustomerBankingInfo;
    }());
    return CustomerBankingInfo;
});
//# sourceMappingURL=customerBankingInfo.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerBankingInfo.js
// module id = 186
// module chunks = 2